import React, { useState } from "react";

import { DateTime } from "luxon";

import { TemplateSearchQueryContext } from "./template-search-context";
import { DocumentState } from "constants/index";
import { TemplateSearchQuery } from "types/search-display";

interface templateSearchContextWrapperProps {
  children: React.ReactNode;
}

const TemplateSearchContextWrapper = ({
  children,
}: templateSearchContextWrapperProps) => {
  const defaultDateFrom = DateTime.now()
    .minus({ years: 1 })
    .startOf("day")
    .toJSDate();
  const defaultDateTo = DateTime.now()
    .plus({ days: 1 })
    .endOf("day")
    .toJSDate();

  const [templateSearchQueryState, setTemplateSearchQueryState] =
    useState<TemplateSearchQuery>({
      orgID: "",
      ownerID: "",
      name: "",
      dateFrom: defaultDateFrom,
      dateTo: defaultDateTo,
      state: DocumentState.ACTIVE,
    });

  const templateSearchContextValue = {
    templateSearchQueryState: templateSearchQueryState,
    setTemplateSearchQueryState: setTemplateSearchQueryState,
  };

  return (
    <TemplateSearchQueryContext.Provider value={templateSearchContextValue}>
      {children}
    </TemplateSearchQueryContext.Provider>
  );
};

export default TemplateSearchContextWrapper;
